export const SIGNATURE_PROVIDERS = {
    crealo_sign: { key: "crealo_sign" as const, label: "Crealo Sign" },
    docoon: { key: "docoon" as const, label: "Docoon" },
} as const;

export type SignatureProviderKey = keyof typeof SIGNATURE_PROVIDERS;
export type SignatureProvider = (typeof SIGNATURE_PROVIDERS)[SignatureProviderKey];

// Keys of providers managed via integrations (not native). Add new external providers here.
export const EXTERNAL_SIGNATURE_PROVIDER_KEYS: SignatureProviderKey[] = ["docoon"];
